import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSite } from "../context/SiteContext";
import Crest from "./Crest";

export default function Footer() {
  const { c } = useSite();
  const { footer, brand } = c;
  const navigate = useNavigate();
  const location = useLocation();
  const targets = [
    ["#origins", "#name", "#kin", "#lineage"],
    ["#legacy", "#tree", "#distribution", "/cave"],
    ["#gathering", "/press", "/notable", "/contact"],
  ];
  const handle = (target) => {
    if (!target) return;
    if (target.startsWith("/")) {
      navigate(target);
      window.scrollTo(0, 0);
      return;
    }
    const id = target.slice(1);
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 300);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <footer className="bg-ink2 border-t border-[var(--c-border)] pt-20 pb-10">
      <div className="max-w-[1220px] mx-auto px-5 sm:px-8">
        <div className="grid md:grid-cols-4 gap-12">
          <div>
            <div className="flex items-center gap-3">
              <Crest size={38} />
              <span className="font-display text-2xl tracking-[0.16em] text-parchment uppercase">{brand.name}</span>
            </div>
            <p className="font-display italic text-xl text-gold mt-5">{brand.motto}</p>
            <p className="text-sm text-parchment/45 font-light mt-2">{brand.mottoEn}</p>
          </div>
          {footer.cols.map((col, i) => (
            <div key={i}>
              <h4 className="font-label text-[0.68rem] uppercase tracking-[0.22em] text-gold mb-5">{col.title}</h4>
              <ul className="space-y-3">
                {col.links.map((l, j) => (
                  <li key={j}>
                    <button
                      data-testid={`footer-link-${i}-${j}`}
                      onClick={() => handle(targets[i]?.[j])}
                      className="text-parchment/55 hover:text-parchment hover:text-gold font-light transition-colors text-left"
                    >
                      {l}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="rule-gold my-12 opacity-40" />

        <div className="flex flex-col sm:flex-row items-center justify-between gap-5">
          <div className="flex gap-7">
            {footer.legal.map((l, i) => (
              <button key={i} className="font-label text-[0.66rem] uppercase tracking-[0.18em] text-parchment/45 hover:text-gold transition-colors">
                {l}
              </button>
            ))}
          </div>
          <p className="font-label text-[0.66rem] uppercase tracking-[0.18em] text-parchment/40">
            © {new Date().getFullYear()} {brand.wordmark}
          </p>
        </div>
        <p className="text-xs text-parchment/30 font-light mt-8 max-w-3xl leading-relaxed">{footer.note}</p>
      </div>
    </footer>
  );
}
